import { TileRateApartment } from '@nocowanie/noc-api';

export const APARTMENT_TYPE_LABEL = {
    [TileRateApartment.roomType.APARTMENT]: {
        label: 'Apartament',
        type: TileRateApartment.roomType.APARTMENT,
    },
    [TileRateApartment.roomType.ROOM]: {
        label: 'Pokój',
        type: TileRateApartment.roomType.ROOM,
    },
    [TileRateApartment.roomType.SUITE]: {
        label: 'Rezydencja',
        type: TileRateApartment.roomType.SUITE,
    },
    [TileRateApartment.roomType.COMPLETE]: {
        label: 'Domek',
        type: TileRateApartment.roomType.COMPLETE,
    },
};
